var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSortDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.927,
    height: 15.428,
    viewBox: "0 0 10.927 15.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.428,4.964a.469.469,0,0,0-.132-.322L9.833.133a.448.448,0,0,0-.638,0,.458.458,0,0,0,0,.644L12.89,4.508H.451a.455.455,0,0,0,0,.911H12.889L9.2,9.15a.458.458,0,0,0,0,.644.448.448,0,0,0,.638,0L14.3,5.286A.467.467,0,0,0,14.428,4.964Z",
    transform: "translate(10.427 0.5) rotate(90)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortDown);
export default __webpack_public_path__ + "static/media/icon_sort_down.877442e364c56ed813257da07b702425.svg";
export { ForwardRef as ReactComponent };